
	import {
		Component,
		Model,
		Prop,
		Vue,
		Watch
	} from "vue-property-decorator";

	import {
		roleSave,
		roleDetail
	} from '@/api/auth';

	import {
		asyncRoutes
	} from '@/router'

	import PageFooter from '@/components/page-footer.vue';
	import Dialog from '@/components/dialog.vue';
	

	@Component({
		name: 'edit-role-dialog',
		components: {
			'role-dialog': Dialog
		}
	})
	export default class AuthRoles extends Vue {

		@Model('change') visible!: Boolean;
		@Prop({default: 0}) id!:Number;
		private showDialog = false;
		private loading = false;
		private treeList = [];
		private ruleForm = {
			name: ''
		}
		private rules = {
			name: [{
				required: true,
				message: '请输入角色名称',
				trigger: 'blur'
			}]
		}
		private radio = '1';
		private radio1 = 0;
		private radio2 = '1';
		private roleIds = [16];
		private selectedRoleIds = [];
		private ScheduleProductCheckPermissions = [1,2,3,4]
		private ProductSellCountAnalysisDailyDataPermissions = [1,2,3,4];
		

		@Watch('visible')
		private async onChangeVisible(e) {
			this.showDialog = e;

			if (this.showDialog) {
				// this.getMenuList();
				this.getDetail();
				
				if (this.id){
					
				}else{
					this.ruleForm.name = '';
					
					await this.$nextTick();
					let ref:any = this.$refs['tree'];
					ref.setCheckedKeys([]);
					
				}
			}
		}
		private view(node, data){
			console.log(node, data)
		}
		
		private showSecretRadio(data){
			return this.roleIds.indexOf(data.id) > -1 ? true : false;
		}
		private secretChecked(data){
			let b = this.selectedRoleIds.indexOf(data.id) > -1 ? '1' : '2';
			return b;
		}
		private secretCheckedChange(type, data){
			if (type === '1'){
				if (this.selectedRoleIds.indexOf(data.id) < 0){
					this.selectedRoleIds.push(data.id)
				}
			}else{
				this.selectedRoleIds = this.selectedRoleIds.filter(item=>{
					return item !== data.id;
				})
			}
			// console.log(this.selectedRoleIds)
		}
		
		//编辑的时候  获取角色详情
		private async getDetail(){
			try{
				const res:any = await roleDetail({
					Id: this.id
				})
				
				this.ruleForm.name = res.Result.Name;
				this.radio = res.Result.DeliveryManagementIsPartPermissions ? '2':'1';
				this.radio1 = res.Result.ActivityCouponPermission;
				this.radio2 = res.Result.ProductLibraryIsPartPermissions ? '2':'1';
				this.selectedRoleIds = res.Result.FullPhoneMenuPermissions || [];
				this.ScheduleProductCheckPermissions = res.Result.ScheduleProductCheckPermissions||[1,2,3,4];
				this.ProductSellCountAnalysisDailyDataPermissions = res.Result.ProductSellCountAnalysisDailyDataPermissions||[1,2,3,4];
				await this.$nextTick();
				let keys:any = [];
				res.Result.EmployeeRolePcMenuList.map((item:any)=>{
					let count = 0;
					item.EmployeeRoleChildMenuList.map((obj:any)=>{
						if (obj.IsCheck){
							keys.push(obj.Id);
							count ++;
						}
					})

					if (item.EmployeeRoleChildMenuList.length){
						if (item.EmployeeRoleChildMenuList.length === count){
							keys.push(item.Id);
						}
					}else{
						if (item.IsCheck){
							keys.push(item.Id);
						}
					}
					

				})

				let ref:any = this.$refs['tree'];
				ref.setCheckedKeys(keys);
				// console.log(res.Result.EmployeeRolePcMenuList)
				this.filterMenu(res.Result.EmployeeRolePcMenuList);
				
			}catch(err){
				
			}
		}

		//获取权限菜单列表
		private async getMenuList() {
			
			// try{
			// 	const res:any = await employeeRoleDetail({});
			// 	this.filterMenu(res.Result);
			// }catch(err){
			// 	console.log(err)
			// }
			
		}
		
		private filterMenu(array:any){
			let list: any = [];
			array.map(item => {
				let children: any = [];
				if (item.EmployeeRoleChildMenuList) {
					 
					
					item.EmployeeRoleChildMenuList.map(obj => {
						 let subChildren: any = [];
						if (obj.EmployeeRoleChildMenuList){
							obj.EmployeeRoleChildMenuList.map(obj1=>{
								subChildren.push({
									id: obj1.Id,
									label: obj1.Text,
									sref: obj1.Sref
								})
							})
						}
						
						let child:any = {
							id: obj.Id,
							label: obj.Text,
							sref: obj.Sref
						}
						
						if (subChildren.length) {
							child.children = subChildren;
						}
						
						children.push(child)
					})
				}
		
				let obj: any = {
					id: item.Id,
					label: item.Text,
					sref: item.Sref
				}
		
				if (children.length) {
					obj.children = children;
				}
		
				list.push(obj)
			})
			
			this.treeList = list;
			// console.log(this.treeList)
		}

		//关闭弹框
		private handleClose() {
			this.showDialog = false;
			this.$emit('change', false)
		}

		//保存
		private handleSave() {
			let ref:any = this.$refs['ruleForm'];
			ref.validate((valid) => {
				if (valid) {
					this.saveData();
				}
			});
		}
		private async saveData(){
			try{
				this.loading = true;
				let ref:any = this.$refs['tree'];
				let keys = ref.getCheckedKeys();
				// console.log(this.treeList)
				this.treeList.map(item=>{
					
					if (item.children){
						let haveChild = false;
						item.children.map(obj=>{
							if (keys.indexOf(obj.id) > -1){
								haveChild = true;
							}
						})

						if (keys.indexOf(item.id) < 0 && haveChild){
							keys.push(item.id)
						}
					}
					
				})

				const params:any = {
					Id: this.id,
					Name: this.ruleForm.name,
					PcPermissions: keys,
					DeliveryManagementIsPartPermissions: this.radio === '2',
					ActivityCouponPermission: this.radio1,
					ProductLibraryIsPartPermissions: this.radio2 === '2',
					FullPhoneMenuPermissions: this.selectedRoleIds,
					ScheduleProductCheckPermissions:this.ScheduleProductCheckPermissions,
					ProductSellCountAnalysisDailyDataPermissions: this.ProductSellCountAnalysisDailyDataPermissions,
				}
				
				// console.log(params);
				// return;

				const res:any = await roleSave(params);
				
				this.$message.success('保存成功');
				this.$emit('reload');
				this.handleClose();
				
			}catch(err){
				console.log(err)
				this.loading = false;
			}
		}
		
		/**
		 * 节点选中事件
		 * 共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
		 */
		checkChange(data, bol, childData){
			// console.log(data, bol, childData)
			if (data.sref === 'deliverymanagement' && !bol){
				this.radio = '1'
			}
		}
	}
